import { render, staticRenderFns } from "./BaseLogoSe.vue?vue&type=template&id=19b967c8&"
import script from "./BaseLogoSe.vue?vue&type=script&lang=ts&"
export * from "./BaseLogoSe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports